import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { MsalGuard } from '@azure/msal-angular';

export const AppRoutes: Routes = [{
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },{
        path: '',
        component: AdminLayoutComponent,
        children: [{
            path: 'dashboard',
            loadChildren: () => import('./dashboard/dashboard.module').then(x => x.DashboardModule)
          }, {
            path: 'usermanagement',
            canActivate: [MsalGuard],
            loadChildren: () => import('./usermanagement/usermanagement.module').then(x => x.UserManagementModule)
          }, {
            path: 'patientmanagement',
            canActivate: [MsalGuard],
            loadChildren: () => import('./patientmanagement/patientmanagement.module').then(x => x.PatientManagementModule)
          }, {
            path: 'portalmanagement',
            canActivate: [MsalGuard],
            loadChildren: () => import('./portalmanagement/portalmanagement.module').then(x => x.PortalManagementModule)
          }, {
            path: '',
            loadChildren: () => import('./disclaimer/disclaimer.module').then(x => x.DisclaimerModule)
          }, {
            path: '',
            loadChildren: () => import('./impressum/impressum.module').then(x => x.ImpressumModule)
          }]
      }
];
